import { useContext, useDebugValue } from 'react';
import AuthContext from '../context/AuthProvider';

interface IAuthContext {
  auth: {
    user?: string;
    accessToken: string;
    roles: string[];
    aiTrainingComplete?: boolean;
  };
  setAuth: React.Dispatch<
    React.SetStateAction<{
      accessToken: string;
      user?: string | undefined;
      roles: string[];
      aiTrainingComplete?: boolean | undefined;
    }>
  >;
}

const useAuth = () => {
  const { auth } = useContext(AuthContext) as IAuthContext;

  useDebugValue(auth, (authorization) =>
    authorization?.user ? 'Logged In' : 'Logged Out',
  );
  return useContext(AuthContext) as IAuthContext;
};

export default useAuth;
